import React from 'react'
import { Strategy } from '@/types'
import { LessonNavigateTo } from '../utils'
import { LessonStrategyParams } from '../types'
import { resolveStrategyAction } from '@/utils'

export function useSecondaryCTA() {
  const strategies = React.useMemo(() => [
    {
      matches: ({ chapter }) => chapter.secondary_cta.enabled && !!chapter.secondary_cta.prompt,
      execute: ({ chapter }) => LessonNavigateTo.Contribute(chapter.secondary_cta.prompt, chapter.id),
      name: 'prompt',
      shouldNavigate: true,
    },
    {
      matches: () => true,
      execute: () => {},
      name: 'share',
      shouldNavigate: false,
    },
  ] satisfies Strategy<LessonStrategyParams>[], [])

  const resolve = React.useCallback((params: LessonStrategyParams) => {
    return resolveStrategyAction(params, strategies, 'useSecondaryCTA')
  }, [strategies])

  return { resolve }
}
